import React from 'react';
import FactoringSummaryView from '@fingo/lib/features/factoring/components/summaries/FactoringSummary';
import getColumns from '../../constants/available-factoring';

const FactoringSummary = (props) => (
  <FactoringSummaryView {...props} getColumns={getColumns} />
);

export default FactoringSummary;
